<icc-list
  [searchable]="true"
  [items]="doorPanelTrims"
  [itemTemplate]="itemTrim"
  (select)="select($event)"
  [selected]="selectedTrim"
  [vertical]="true"
></icc-list>

<ng-template #itemTrim let-item="iccListItem">
  <div class="item-imgTitleDescription item-imgTitleDescription--vertical">
    <p class="item-imgTitleDescription-title">{{item.title}}</p>
    <div class="icc-list-item-img-container">
      <img class="item-imgTitleDescription-img" [src]="item.imageUrl" [alt]="item.title" defaultImg>
    </div>
    <div class="item-imgTitleDescription-price">
      @if (item.price != null) {
        <span>
          {{ 'CONFIGURATOR|Cena' | translate }}:<br>
          @if (item.listPrice && item.listPrice !== item.price && listPriceEnable && listPriceEnableInMarket) {
            <s>
              {{priceMarket(item.listPrice) | currency: currency}}
            </s>
          }
          @if ((listPriceEnable && listPriceEnableInMarket) || !listPriceEnable || !item.listPrice) {
            <span>
              {{priceMarket(item.price) | currency: currency}}
            </span>
          }
          @if (listPriceEnable && !listPriceEnableInMarket && item.listPrice) {
            <span>
              {{priceMarket(item.listPrice) | currency: currency}}
            </span>
          }
          <br>
          </span>
        }
      </div>
    </div>
  </ng-template>
